import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Breadcrumb } from 'react-bootstrap'
const { Item } = Breadcrumb

class BreadcrumbComponent extends Component {
  constructor(props) {
    super(props);
    this.state = { items: [] };
  }

  UNSAFE_componentWillMount() {
    this.setState({ ...this, items: this.props.items })
  }
  render() {
    return (
      <Breadcrumb style={{backgroundColor:'#f3f3f4', borderColor:'#f3f3f4'}} className='py-2' label='asd'>
        <Item href='/dashboard' style={{backgroundColor:'#f3f3f4', borderColor:'#f3f3f4'}}>Home</Item>
        {this.state.items.map((item, _) => {
          let path = item.split(';')[0]
          let name = item.split(';')[1]
          return <Item key={_} href={path} style={{backgroundColor:'#f3f3f4'}} active={path === 'self'}>{name}</Item>
        })}
      </Breadcrumb>
    )
  }
  componentWillUnmount() { }
}

const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(BreadcrumbComponent);



// WEBPACK FOOTER //
// ./src/components/theme/breadcrumb/index.jsx